import heroSmall from "../assets/hero-960.webp";
import heroLarge from "../assets/hero-1920.webp";
import heroFallback from "../assets/hero-fallback.jpg";

function Hero({ t }) {
  return (
    <section
      id="hero"
      className="hero"
    >

      <picture className="hero-picture">
        <source type="image/webp" srcSet={`${heroSmall} 960w, ${heroLarge} 1920w`} sizes="100vw" />
        <img src={heroFallback} alt="" width="1920" height="1275" fetchPriority="high" loading="eager" />
      </picture>
      <div className="hero-overlay"></div>

      <div className="hero-content">
        <h1>{t.heroTitle}</h1>
        <p>{t.heroDesc}</p>
      </div>

    </section>
  );
}

export default Hero;
